import React from 'react';
import { CheckCircle, RefreshCw } from 'lucide-react';
import { Button } from '../ui/button';

const SurveillanceSecurityTab = ({ vulnerabilities, fetchNetFlowData }) => (
  <div className="space-y-6">
    <div className="flex items-center justify-between">
      <h3 className="font-semibold text-gray-900">Firmware Vulnerabilities</h3>
      <Button variant="outline" onClick={fetchNetFlowData}><RefreshCw className="h-4 w-4 mr-2" />Refresh Scan</Button>
    </div>

    {vulnerabilities && (
      <>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <div className="bg-white rounded-xl border shadow-sm p-4 text-center">
            <p className="text-3xl font-bold text-gray-900">{vulnerabilities.devices_checked}</p>
            <p className="text-sm text-gray-500">Devices Checked</p>
          </div>
          <div className="bg-white rounded-xl border shadow-sm p-4 text-center">
            <p className="text-3xl font-bold text-orange-600">{vulnerabilities.devices_vulnerable}</p>
            <p className="text-sm text-gray-500">Vulnerable</p>
          </div>
          <div className="bg-white rounded-xl border shadow-sm p-4 text-center">
            <p className="text-3xl font-bold text-red-600">{vulnerabilities.total_vulnerabilities}</p>
            <p className="text-sm text-gray-500">Total CVEs</p>
          </div>
          <div className="bg-white rounded-xl border shadow-sm p-4 text-center">
            <p className="text-3xl font-bold text-red-700">{vulnerabilities.critical_count}</p>
            <p className="text-sm text-gray-500">Critical</p>
          </div>
        </div>

        <div className="space-y-4">
          {vulnerabilities.vulnerabilities?.map((device) => (
            <div key={device.device_id} className="bg-white rounded-xl border shadow-sm p-4">
              <div className="flex items-center justify-between mb-3">
                <div>
                  <p className="font-medium text-gray-900">{device.device_name}</p>
                  <p className="text-sm text-gray-500">{device.manufacturer} - Firmware: {device.current_firmware}</p>
                </div>
                <span className={`px-3 py-1 rounded-full text-sm font-medium ${device.risk_score >= 70 ? 'bg-red-100 text-red-700' : device.risk_score >= 40 ? 'bg-orange-100 text-orange-700' : 'bg-yellow-100 text-yellow-700'}`}>
                  Risk: {device.risk_score}/100
                </span>
              </div>
              <div className="space-y-2">
                {device.vulnerabilities?.map((vuln, idx) => (
                  <div key={vuln.id || vuln.name || idx} className={`p-3 rounded-lg ${vuln.severity === 'critical' ? 'bg-red-50' : vuln.severity === 'high' ? 'bg-orange-50' : 'bg-yellow-50'}`}>
                    <div className="flex items-start justify-between">
                      <div>
                        <p className="font-mono text-sm font-medium">{vuln.cve}</p>
                        <p className="text-sm text-gray-600">{vuln.description}</p>
                      </div>
                      <div className="flex gap-2">
                        <span className={`px-2 py-0.5 rounded text-xs ${vuln.severity === 'critical' ? 'bg-red-200 text-red-700' : vuln.severity === 'high' ? 'bg-orange-200 text-orange-700' : 'bg-yellow-200 text-yellow-700'}`}>{vuln.severity}</span>
                        {vuln.patch_available && <span className="px-2 py-0.5 bg-green-100 text-green-700 rounded text-xs">Patch Available</span>}
                        {vuln.exploited_in_wild && <span className="px-2 py-0.5 bg-red-200 text-red-700 rounded text-xs">Active Exploit</span>}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}

          {vulnerabilities.vulnerabilities?.length === 0 && (
            <div className="bg-white rounded-xl border shadow-sm p-12 text-center">
              <CheckCircle className="h-16 w-16 mx-auto mb-4 text-green-300" />
              <h4 className="font-medium text-gray-700 mb-2">No vulnerabilities detected</h4>
              <p className="text-sm text-gray-500">All devices have up-to-date firmware</p>
            </div>
          )}
        </div>
      </>
    )}
  </div>
);

export default SurveillanceSecurityTab;
